import { components } from "@/lib/openapi";
import { client } from "@/queries/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function getAllRules() {
  return useQuery({
    queryKey: ["playlists"],
    queryFn: async ({ signal }) => {
      const { data, error } = await client
        .get()
        .GET("/api/playlist/rules", { signal });
      if (data) return data;
      console.warn(error);
      throw new Error();
    },
  });
}

export function createRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      createData: components["schemas"]["RuleCreateSchema"]
    ) => {
      const { data, error } = await client.get().POST("/api/playlist/rule", {
        body: createData,
      });
      if (data) return data;
      console.warn(error);
      throw new Error();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["playlists"] });
    },
  });
}

export function updateRule(rule_id: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      updateData: components["schemas"]["RuleUpdateSchema"]
    ) => {
      const { data, error } = await client
        .get()
        .PATCH("/api/playlist/rule/{rule_id}", {
          params: {
            path: {
              rule_id,
            },
          },
          body: updateData,
        });
      if (data) return data;
      console.warn(error);
      throw new Error();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["playlists"] });
    },
  });
}

export function deleteRule(rule_id: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { data, error } = await client
        .get()
        .DELETE("/api/playlist/rule/{rule_id}", {
          params: {
            path: {
              rule_id,
            },
          },
        });
      if (data) return data;
      console.warn(error);
      throw new Error();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["playlists"] });
    },
  });
}

export function getLocations(locationTypes: string[]) {
  return useQuery({
    queryKey: ["locations", locationTypes],
    queryFn: async ({ signal }) => {
      const { data, error } = await client
        .get()
        .POST("/api/playlist/locations", {
          body: { location_types: locationTypes },
          signal,
        });
      if (data) return data;
      console.warn(error);
      throw new Error();
    },
    enabled: locationTypes.length > 0,
  });
}

export function getSuggestedPlays() {
  return useQuery({
    queryKey: ["suggested_plays"],
    queryFn: async ({ signal }) => {
      const { data, error } = await client
        .get()
        .GET("/api/playlist/suggested_plays", { signal });
      if (data) return data;
      console.warn(error);
      throw new Error();
    },
  });
}
